module.exports = __webpack_public_path__ + "glassware.png?e45d4c85658f85ee09c6ab63d542fdcf";